import { render, staticRenderFns } from "./PacklistAlertStatsDialog.vue?vue&type=template&id=bc3fbc4c&scoped=true"
import script from "./PacklistAlertStatsDialog.vue?vue&type=script&lang=js"
export * from "./PacklistAlertStatsDialog.vue?vue&type=script&lang=js"
import style0 from "./PacklistAlertStatsDialog.vue?vue&type=style&index=0&id=bc3fbc4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3fbc4c",
  null
  
)

export default component.exports